// extracted by mini-css-extract-plugin
export default {"subscribeForm":"SubscribeForm_subscribeForm__uNpFH","navRight":"SubscribeForm_navRight__WwZcd"};